import React from "react";
import { Link } from "react-router-dom";
import { routes } from "../../../../routers/routes";
import { CategoriesData } from "../../../../data/pages/Blog";
import { CategoriesTitle } from "../../../../constants";

const Categories = () => {
  return (
    <div className="blog-sidebar-box">
      <div className="sidebar-title">
        <h4>{CategoriesTitle}</h4>
      </div>
      <ul className="category-list">
        {CategoriesData.map((item, index) => (
          <li key={index}>
            <Link to={routes.Pages.Blog.BlogLeftSidebar}>
              <i className={item.icon} />
              {item.title}
              <span>({item.value})</span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Categories;
